import { msg } from "@lingui/core/macro";

export const isNotOnTenantDenyListRuleMessages = {
	name: msg({ message: "Is Not On Tenant Deny List" }),
	description: msg({ message: "Vehicles must not be on the deny list for the permit's tenant" }),
	errors: {
		vehicleOnDenyList: msg({ message: "Vehicle is on the deny list for the tenant on this permit: {plates}" }),
	},
} as const;
